import { AlertModal, SideModalBody, SideModalFooter, useModalsActions } from 'shared/ui/SideModal';
import { Button } from 'shared/ui/Button';
import { useUpdateHolidaySchedule } from 'entities/profile';
import classNames from 'classnames';
import { useGetOnboardingStatus } from 'widgets/CampaignOnboarding';
import { logError } from 'shared/lib/log-errors';

import { Schedule } from './Schedule';
import { WarningAlert } from './WarningAlert';
import { useHolidaysIsDirtyValue, useHolidaysIsWarningValue, useHolidaysValues } from './store/store';
import { holidaysToSubmit } from './lib';
import style from './HolidayScheduleModalBody.module.scss';

export function HolidayScheduleModalBody() {
  const { close, forceClose } = useModalsActions();
  const holidays = useHolidaysValues() || {};
  const isWarning = useHolidaysIsWarningValue();
  const isDirty = useHolidaysIsDirtyValue();

  const getOnboardingStatusQuery = useGetOnboardingStatus(false);
  const updateHolidayScheduleQuery = useUpdateHolidaySchedule({
    successText: 'Your holiday schedule was successfully updated.',
  });

  const isLoading = updateHolidayScheduleQuery.isLoading;

  const onSubmit = () => {
    updateHolidayScheduleQuery.mutate(
      {
        payload: holidaysToSubmit(holidays),
      },
      {
        onSuccess: () => {
          getOnboardingStatusQuery.refetch().catch(logError);
          forceClose();
        },
      }
    );
  };

  return (
    <>
      <SideModalBody
        title="Holiday schedule"
        titleIcon="beach_access"
        titleIconClassName="text-slate-800"
        className="overflow-y-auto"
        isOverflowYScroll={false}
      >
        <div className="text-sm text-slate-700">
          Let us know when your office is closed for the holidays. Your partnerships manager will take care of your
          campaign and you will have limited number of leads these dates.
        </div>
        <Schedule className={classNames(style.scroll, 'mx-[-69px] mt-2 overflow-y-scroll')} />
        <WarningAlert />
      </SideModalBody>
      <AlertModal showCondition={isDirty} />
      <SideModalFooter>
        <div className="flex justify-between gap-4">
          <Button
            className="w-full"
            onClick={close}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            className="w-full-screen w-[231px] shrink-0"
            loading={isLoading}
            disabled={!isDirty || isWarning}
          >
            Save changes
          </Button>
        </div>
      </SideModalFooter>
    </>
  );
}
